import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import {IDGenerator} from "@wm/core";

const tagName = 'button';
const idGen = new IDGenerator('wm_button');

register('wm-button', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
            const counter = idGen.nextUid() // TODO removed ${counter}.hint || ${counter}.caption || -- - expr changed error
            return `<${tagName} wmButton #${counter}="wmButton" [attr.aria-label]="'Button'" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
